<template>
  <v-tooltip v-if="activateCondition" bottom dark>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :color="color"
        x-small
        :disabled="disabledCondition"
        @click.stop="action"
        v-on="on"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span style="color: white">{{ title }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: [
    'activateCondition',
    'disabledCondition',
    'title',
    'icon',
    'action',
    'color'
  ]
}
</script>
